import React, { useContext, useState } from "react";
import { Button, Form } from "react-bootstrap";
import {
  SearchableList,
  FieldDropSide,
  ManageRkaasLayout,
  CsplTable as Table,
  FieldInputAlphaNumeric,
  FieldInput,
} from "../../../components";
import {
  MANAGE_RKAAS_ROUTES,
  manageRkaasFormNames,
  formFields,
  FLOW_TYPES,
  getPathWithParam,
  getAdvancedPathWithParam,
} from "../../../utils";
import { manageRkaasStore } from "../../../contexts";
import { useDeepEffect, useRouterParams } from "../../../abstracts";
import {
  faTimes,
  faTrashAlt,
  faPencilAlt,
} from "@fortawesome/pro-light-svg-icons";
import { Field, Formik } from "formik";
import { isEmpty } from "lodash";

const CustomReports = (props) => {
  const { history } = props;
  const { state, dispatch } = useContext(manageRkaasStore);
  const { flow, custodianId } = useRouterParams();
  const [newFlow, setNewFlow] = useState(
    flow != FLOW_TYPES.ADD
      ? flow != FLOW_TYPES.SAVE
        ? FLOW_TYPES.EDIT
        : FLOW_TYPES.SAVE
      : FLOW_TYPES.ADD
  );
  const formName = manageRkaasFormNames.ADD_CUSTOMREPORTS;
  const fields = formFields[formName];
  const all = { label: "All", value: null };

  const buttons = [
    {
      label: "Cancel",
      variant: "secondary",
      type: "button",
      flow: [FLOW_TYPES.ADD, FLOW_TYPES.SAVE],
      link: getPathWithParam({
        path: MANAGE_RKAAS_ROUTES.CUSTOM_REPORTS,
      }),
    },
    {
      label: "Save",
      variant: "primary",
      type: "submit",
      flow: [FLOW_TYPES.ADD],
    },
    {
      label: "Save",
      variant: "primary",
      type: "submit",
      flow: [FLOW_TYPES.SAVE],
    },
  ];

  return (
    <>
      <Formik
        initialValues={{}}
        // onSubmit={onFormSubmit}
        // enableReinitialize
        // validateOnChange={false}
        // validateOnBlur={false}
      >
        {(formProps) => {
          const {
            handleChange,
            setFieldValue,
            handleSubmit,
            setValues,
            setTouched,
            values,
            setSubmitting,
            setFieldError,
            fieldValue,
            ...rest
          } = formProps;
          return (
            <Form
              autoComplete="off"
              className="h-100"
              onSubmit={handleSubmit}
              validated={!isEmpty(rest.errors)}
            >
              <ManageRkaasLayout
                layoutHeader={"Custom Reports"}
                buttons={buttons}
                pageFlow={flow}
              >
                <p className="custom-reports-header">Select Category</p>
                <Field
                  size="smd"
                  isRequired
                  name={fields.accountType}
                  label={"Account name"}
                  // value={values[fields.accountType]}
                  options={[all]}
                  popupContent={
                    <SearchableList
                      label="Select account type"
                      selectedValue={values[fields.accountType]}
                      options={[all]}
                      onSelect={(value) =>
                        setFieldValue(fields.accountType, value)
                      }
                    />
                  }
                  component={FieldDropSide}
                />
                <div className="w-75 d-flex flex-row justify-content-between">
                  <Field
                    size="smd"
                    isRequired
                    name={fields.accountName}
                    label={"Account name"}
                    value={values[fields.accountName]}
                    options={[all]}
                    popupContent={
                      <SearchableList
                        label="Select account type"
                        selectedValue={values[fields.accountName]}
                        options={[all]}
                        onSelect={(value) =>
                          setFieldValue(fields.accountName, value)
                        }
                      />
                    }
                    component={FieldDropSide}
                  />
                  <Button
                    className="m-auto"
                    variant={"secondary"}
                    size="sm"
                    type="button"
                    label="Add Employee"
                  >
                    Add Account
                  </Button>
                </div>

                <p className="mt-2 mb-2 custom-reports-header">
                  Select Sub Category
                </p>

                <div className="w-75 d-flex flex-row justify-content-between">
                  <Field
                    size="smd"
                    isRequired
                    name={fields.employee}
                    label={"Employee/s"}
                    onChange={handleChange}
                    value={values[fields.accountName]}
                    component={FieldInput}
                  />
                  <Button
                    className="m-auto"
                    variant={"secondary"}
                    size="sm"
                    type="button"
                    label="Add Employee"
                  >
                    Add Employee
                  </Button>
                </div>
                <div className="w-75 d-flex flex-row justify-content-between">
                  <Field
                    size="smd"
                    isRequired
                    name={fields.investment}
                    label={"Investment/s"}
                    onChange={handleChange}
                    value={values[fields.investment]}
                    component={FieldInput}
                  />
                  <Button
                    className="m-auto"
                    variant={"secondary"}
                    size="sm"
                    type="button"
                    label="Add Employee"
                  >
                    Add Investment
                  </Button>
                </div>

                <div className="w-75 d-flex flex-row justify-content-between">
                  <Field
                    size="smd"
                    isRequired
                    name={fields.source}
                    label={"Source/s"}
                    onChange={handleChange}
                    value={values[fields.accountName]}
                    component={FieldInputAlphaNumeric}
                  />
                  <Button
                    className="m-auto"
                    variant={"secondary"}
                    size="sm"
                    type="button"
                    label="Add Employee"
                  >
                    Add Source
                  </Button>
                </div>
              </ManageRkaasLayout>
            </Form>
          );
        }}
      </Formik>
    </>
  );
};

export default CustomReports;
